import axios from "../utils/axios";

export const getList = () => {
    return axios.get("/Pool/GetList");
};
export const getTaskList = (data) => {
    return axios.post("/AutonomousMaintenance/GetTaskPage", data);
};
export const getupdateTaskDate = () => {
    return axios.get("/MaintenanceType/GetList");
};

export const getMainListByAreaID = (areaID) => {
    return axios.get("/Equipment/GetMainListByAreaID?areaId=" + areaID);
};

export const getSubListById = (mainEquipmentID) => {
    return axios.get("/Equipment/GetSubListById?equipmentId=" + mainEquipmentID);
};

export const getAreaList = () => {
    return axios.get("/Area/GetList");
};

export const getTaskDetailById = (clickedEventId) => {
    return axios.get("/AutonomousMaintenance/GetTaskById?id=" + clickedEventId);
};

export const getListMaintenanceType = () => {
    return axios.get("/CostCenter/GetCostCenterList");
};

export const getEquipmentSubListById = (areaID) => {
    return axios.get("/Equipment/GetMainListByAreaID?areaId=" + areaID);
};
